import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    stores: [],
    currentStore: {},
    storesByZone: [],
    pageCount: 1,
    storesGrouped: {},
};

const stores = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.ADD_STORES) {
        return { ...state, stores: action.payload };
    }

    if (action.type === APP_ACTIONS.ADD_STORES_BY_ZONE) {
        return { ...state, storesByZone: action.payload.storesByZone, pageCount: action.payload.pageCount };
    }

    if (action.type === APP_ACTIONS.SET_CURRENT_STORE) {
        return { ...state, currentStore: action.payload };
    }
    if (action.type === APP_ACTIONS.ADD_STORES_GROUPED) {
        return { ...state, storesGrouped: action.payload };
    }
    return state;
};

export default stores;



/** WEBPACK FOOTER **
 ** ./src/reducers/stores.js
 **/